var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5197 42C9.93392 42 0.5 32.5792 0.5 20.9934C0.5 9.42081 9.93392 0 21.5197 0C33.0923 0 42.5131 9.44705 42.5 21.0328C42.4869 32.5792 33.0661 41.9869 21.5197 42ZM18.2526 24.4836C17.5178 23.8144 16.8618 23.2109 16.1926 22.6073C14.9461 21.4789 13.739 20.298 12.44 19.2221C11.2854 18.2643 9.65839 18.8022 9.23852 20.2193C8.96298 21.164 9.31724 21.925 10.0258 22.5548C12.2301 24.5492 14.4213 26.5567 16.6256 28.5511C17.9377 29.7451 18.8955 29.7057 20.142 28.4724C22.5037 26.1368 24.8655 23.7882 27.2141 21.4527C29.1692 19.5108 31.1242 17.5689 33.0792 15.6401C33.7352 14.9972 34.0633 14.2493 33.7483 13.3308C33.1842 11.717 31.3866 11.3496 30.1139 12.6092C28.2376 14.4724 26.3744 16.3486 24.4981 18.2118C22.425 20.2849 20.365 22.358 18.2526 24.4836Z",
    fill: "#FC6631"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightCheckIcon);
export default __webpack_public_path__ + "static/media/right-check-icon.c9a050f2f6dad9d58ac9c3dd2a18cf9b.svg";
export { ForwardRef as ReactComponent };